import React from 'react';
import styled from 'styled-components';
import { Box, LayoutGridItem, PageTitle, Tooltip } from '@cko/primitives';
import { IconActionInfo } from '@cko/icons';
const ActionBar = styled(LayoutGridItem) `
  display: flex;
  grid-auto-columns: max-content;
  justify-content: end;
`;
const TooltipWrapper = styled(Box) `
  display: inline;
  margin-left: var(--layout-stamp);
`;
export const PageHeaderSection = ({ title, children, className, tooltipText, }) => (React.createElement(React.Fragment, null,
    React.createElement(LayoutGridItem, { span: children ? 12 : 24 },
        React.createElement(PageTitle, { className: className, inGrid: true },
            title,
            tooltipText && (React.createElement(TooltipWrapper, null,
                React.createElement(Tooltip, { text: tooltipText, defaultDirection: "right-start" },
                    React.createElement(IconActionInfo, null)))))),
    children && React.createElement(ActionBar, { span: 12 }, children)));
